export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["수거 신청이 완료 되었습니다. \n 마이페이지에 입력된 주소로 영업일 기준 2~3일 내에 한진택배 기사님이 방문할 예정입니다"])}
    }
  })
}
